export const EMAIL_PATTERN_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

// Host labels use [\w-] (no dot) so the `\.` separators are unambiguous, and the
// trailing path class is anchored with `*` after a greedy, non-overlapping host.
// This removes the exponential backtracking of the previous pattern (js/redos)
// while accepting/rejecting the same realistic URLs.
export const URL_PATTERN_REGEX =
  /^(http(s)?:\/\/)[\w-]+(?:\.[\w-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]*$/i;

//this regex will catch both 3 digits with Z and 6 digits:
//2019-09-24T07:03:12.778Z
//2024-09-23T07:52:25.170896
export const DATE_PATTERN_REGEX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3,6})?(?:Z)?$/i;
